module.exports = __webpack_public_path__ + "56a87e9b94c1d9326fe1d8bef8823d56.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/ZM.svg
// module id = HHg+
// module chunks = 0